import {
    GET_SHIPTO_OF_SC_INFOR,
    GET_CMGT_SKU_INFOR,
    BATCH_ADD_SHOPPING_CART
} from "Actions/noScOrder";

const initialState = {
};
let payload = {}

export function noScOrder(state = initialState, action) {   
    switch (action.type) {
        case GET_SHIPTO_OF_SC_INFOR:
        case GET_CMGT_SKU_INFOR:
            return {
                ...state,
                ...action.payload
            }
        case BATCH_ADD_SHOPPING_CART:
                payload = action.payload.cartCount
                return Object.assign({}, state, { batchAddcartCount: payload });
        default:
            return state;
    }
}
